import { render } from "./pending.vue?vue&type=template&id=2df3d7c3&scoped=true"
import script from "./pending.vue?vue&type=script&lang=js"
export * from "./pending.vue?vue&type=script&lang=js"

import "./pending.vue?vue&type=style&index=0&id=2df3d7c3&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df3d7c3"]])

export default __exports__